import React from "react";
import { Link } from "react-router-dom";
import GamingBox from "./gamingBox";
import FeaturedInstallations from "./FeaturedInstallations";
import "../equipment.css";
import "../gaming-experience.css";

export const GamingSection = () => (
  <main className="eq-page gm-page">
    <section className="eq-hero">
      <div className="eq-wrap">
        <p className="eq-eyebrow">TECHNOGENIOUS · GAMING MACHINES</p>
        <h1>
          Your game.
          <br />
          <span>Built for your location.</span>
        </h1>
        <p>
          Explore gaming machines, plan a hardware configuration, and talk to
          our team about purchasing, leasing, or support.
        </p>
        <div className="eq-actions">
          <a className="eq-primary" href="#machines">
            Browse machines ↓
          </a>
          <Link to="/build-your-machine">Build your machine →</Link>
        </div>
        <nav className="gm-lifecycle" aria-label="Gaming machine services">
          <a href="#ownership">Buy</a>
          <Link to="/leasing">Lease</Link>
          <Link to="/build-your-machine">Build</Link>
          <a href="#support">Repair</a>
        </nav>
      </div>
    </section>
    <nav
      className="gm-section-nav gm-wrap"
      aria-label="Gaming machine sections"
    >
      <a href="#machines">Machines</a>
      <Link to="/build-your-machine">Build your machine</Link>
      <a href="#installations">Featured installations</a>
    </nav>
    <section
      id="machines"
      className="eq-wrap eq-catalog"
      aria-label="Gaming machine catalogue"
    >
      <div className="eq-heading">
        <div>
          <p className="eq-eyebrow">EXPLORE THE RANGE</p>
          <h2>Find your gaming machine</h2>
        </div>
        <Link to="/products">Shop parts & accessories →</Link>
      </div>
      <GamingBox />
    </section>
    <section className="gm-wrap gm-config-promo">
      <div>
        <p className="gm-eyebrow">CONFIGURE WITH CONFIDENCE</p>
        <h2>
          Keep the game.
          <br />
          Make the hardware yours.
        </h2>
        <p>
          Review the base configuration, request component upgrades, and see
          your build summary as you go. Our team confirms the details and
          prepares your quotation.
        </p>
        <Link className="gm-primary" to="/build-your-machine">
          Build your machine →
        </Link>
      </div>
      <ol>
        <li>
          <span>01</span>
          <div>
            <h3>Select a game</h3>
            <p>Your chosen game theme stays fixed.</p>
          </div>
        </li>
        <li>
          <span>02</span>
          <div>
            <h3>Review what’s standard</h3>
            <p>Review the standard components included with your machine.</p>
          </div>
        </li>
        <li>
          <span>03</span>
          <div>
            <h3>Choose your hardware</h3>
            <p>
              Bill acceptor, ticket printer, cabinet, monitor, and
              optional hardware.
            </p>
          </div>
        </li>
        <li>
          <span>04</span>
          <div>
            <h3>Request your quotation</h3>
            <p>Send your configuration to our team through WhatsApp.</p>
          </div>
        </li>
      </ol>
    </section>
    <section id="ownership" className="gm-wrap gm-block">
      <p className="gm-eyebrow">A SETUP THAT SUITS YOU</p>
      <h2>Buy or lease. Start with a conversation.</h2>
      <div className="gm-two">
        <article>
          <h3>Buy your gaming machine</h3>
          <p>
            Discuss the game, hardware specification, number of machines,
            installation, and delivery before ordering.
          </p>
          <Link to="/build-your-machine">Plan a purchase →</Link>
        </article>
        <article>
          <h3>Explore leasing</h3>
          <p>
            Tell us about your location and requirements. Our team will discuss
            eligibility, availability, installation, and lease terms.
          </p>
          <Link to="/leasing">
            Why lease with us? →
          </Link>
        </article>
      </div>
    </section>
    <div className="gm-wrap"><FeaturedInstallations /></div>
    <section id="support" className="gm-wrap gm-support">
      <div>
        <p className="gm-eyebrow">SERVICE & SUPPORT</p>
        <h2>Support beyond the build.</h2>
        <p>
          For repairs or maintenance, share your gaming machine model, a
          description of the fault, and any error messages.
        </p>
      </div>
      <Link className="gm-primary" to="/contact">
        Request service support →
      </Link>
    </section>
    <section className="gm-wrap gm-final">
      <h2>Ready to discuss your next gaming machine?</h2>
      <div>
        <Link className="gm-primary" to="/build-your-machine">
          Build & request a quote →
        </Link>
        <a
          href="https://wa.me/18764482032?text=Hello%2C%20I%20would%20like%20to%20discuss%20a%20gaming%20machine."
          target="_blank"
          rel="noopener noreferrer"
        >
          Talk on WhatsApp ↗
        </a>
      </div>
    </section>
  </main>
);
